import { useEffect, useRef } from "react";
import styled from "styled-components";
import Text from "../../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
const MouseTooltip = props => {
  const {
    scene,
    text
  } = props;
  const tooltipText = useRef(null);
  useEffect(function tooltipFollowMouse() {
    const setTooltipPosition = position => {
      if (tooltipText.current) {
        const width = tooltipText.current.clientWidth;
        const height = tooltipText.current.clientHeight;
        tooltipText.current.style.left = "".concat(position.x - width / 2, "px");
        tooltipText.current.style.top = "".concat(position.y - height - 10, "px");
      }
    };
    setTooltipPosition({
      x: scene.canvas.width / 2,
      y: scene.canvas.height / 2
    });
    scene.canvas.addEventListener("mousemove", setTooltipPosition);
    return () => document.removeEventListener("mousemove", setTooltipPosition);
  });
  useEffect(function setCursor() {
    scene.canvas.style.cursor = "crosshair";
    return () => {
      scene.canvas.style.cursor = "auto";
    };
  });
  return /*#__PURE__*/_jsx(TooltipText, {
    ref: tooltipText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  });
};
const TooltipText = styled(Text).attrs({
  small: true,
  textDarker: true,
  textAlignCenter: true
}).withConfig({
  displayName: "MouseTooltip__TooltipText",
  componentId: "sc-1keiuri-0"
})(["position:absolute;width:200px;padding:0.7em;border-radius:", ";border:1px solid grey;background-color:#ffffff;"], p => p.theme.radiusSmall);
export default MouseTooltip;